import React from "react";
import { DropdownComponent } from "../components/forms/dropdown";

export const RenderDropdown = (label, value, options, onChange, disabled = false) => (
  <DropdownComponent
    labelName={label}
    value={value}
    options={options}
    onSearchChange={onChange}
    disabled={disabled}
  />
);

// export const InputField = ({ label, value, onChange, readOnly = false }) => (
//   <div>
//     <label className="form-label">{label}</label>
//     <input
//       className="form-input"
//       type="text"
//       value={value}
//       readOnly={readOnly}
//       onInput={(e) => onChange(e.target.value)}
//     />
//   </div>
// );

// export const InputField = ({ label, value, onChange, readOnly = false, type = "text" }) => (
//   <div>
//     <label className="form-label">{label}</label>
//     <input
//       className="form-input"
//       type={type}
//       value={value}
//       readOnly={readOnly}
//       onChange={(e) => onChange(e.target.value)}
//     />
//   </div>
// );

export const InputField = ({
  label,
  value,
  onChange,
  readOnly = false,
  type = "text",
  decimals,        // optional number of decimal places
  min,             // optional min value
}) => {
  // Determine step based on decimals
  const step = decimals !== undefined ? Math.pow(10, -decimals) : undefined;

  return (
    <div>
      <label className="form-label">{label}</label>
      <input
        className="form-input"
        type={type}
        value={value}
        readOnly={readOnly}
        step={step}
        min={min}
        onChange={(e) => {
          let val = e.target.value;
          if (type === "number" && decimals !== undefined && val !== "") {
            // limit decimals when typing
            const regex = new RegExp(`^-?\\d*(\\.\\d{0,${decimals}})?$`);
            if (!regex.test(val)) return; // ignore invalid input
          }
          onChange(val);
        }}
      />
    </div>
  );
};


export const InputMediumField = ({ label, value, onChange, readOnly = false, type = "text", min, step }) => (
  <div>
    <label className="form-label">{label}</label>
    <input
      className="form-medium-input"
      type={type}
      value={value}
      readOnly={readOnly}
      min={min}
      step={step}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

export const NarrowInputField = ({
  label,
  value,
  onChange,
  readOnly = false,
  type = "text",
  width = "150px",
  labelWidth = "70px",
  gap = "0.5rem", // NEW: allows you to control spacing between label and input
}) => (
  <div
    className="d-flex align-items-center"
    style={{
      maxWidth: `calc(${width} + ${labelWidth} + ${gap})`,
      gap: gap,
      transform: 'translateY(-3px)',
    }}
  >
    <label
      className="form-label mb-0"
      style={{
        minWidth: labelWidth,
        color: '#5791B9',
        fontSize: '16px',
      }}
    >
      {label}
    </label>
    <input
      className="form-input"
      type={type}
      value={value}
      readOnly={readOnly}
      onChange={(e) => onChange(e.target.value)}
      style={{ width: width }}
    />
  </div>
);



// export const NumberInput = ({ label, value, onChange, readOnly = false }) => (
//   <div>
//     <label className="form-label">{label}</label>
//     <input
//       className="form-input"
//       type="number"
//       value={value}
//       readOnly={readOnly}
//       onInput={(e) => onChange(e.target.value)}
//     />
//   </div>
// );

export function To64BitIntFromPriceString(priceStr, priceDecimals) {
   const factor = Math.pow(10, priceDecimals);
   const result = Math.round(parseFloat(priceStr) * factor);
   return result;
}

export const CleanNumber = (val) => val != null ? String(val).replace(/,/g, '') : '';